export enum Pages {
  Chat = '/',
  PDFViewer = '/pdf-viewer',
  Disclaimer = '/disclaimer',
  TopicPicker = '/topic-picker',
  NotFound = '*',
}
